import { QueryConstraint, Unsubscribe } from "firebase/firestore";
import FirestorePipe from "../utils/pipe";
import BillingValues from "../entities/billingValues";

class BillingValuesDB extends FirestorePipe {
    public static readonly colName = "ConfigUget";

    constructor() {
        super(BillingValuesDB.colName);
    }

    public create(data: BillingValues): Promise<string> {
        return this._create(data);
    }

    public update(id: string, data: Partial<BillingValues>): Promise<void> {
        return this._update(id, data);
    }

    public delete(id: string): Promise<void> {
        return this._delete(id);
    }

    public getAll(...params: QueryConstraint[]): Promise<BillingValues[]> {
        return this._getAll<BillingValues>(...params);
    }

    public get(id: string = "BillingValues"): Promise<BillingValues> {
        return this._get<BillingValues>(id);
    }

    public on(
        listener: (data: BillingValues[]) => void,
        ...params: QueryConstraint[]
    ): Unsubscribe {
        return this._on<BillingValues>(listener, ...params);
    }
}

export default BillingValuesDB;
